import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-task-success',
  templateUrl: './task-success.component.html',
  styleUrls: ['./task-success.component.scss']
})
export class TaskSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
